export function parseObject(
  value: string,
  field: string,
  requireNonEmpty = false,
) {
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    throw new Error(`${field}: invalid JSON`);
  }

  if (
    parsed === null ||
    typeof parsed !== "object" ||
    Array.isArray(parsed) ||
    (requireNonEmpty && Object.keys(parsed).length === 0)
  ) {
    throw new Error(
      `${field} must be${requireNonEmpty ? " a non-empty" : ""} JSON object`,
    );
  }
  return parsed as Record<string, unknown>;
}

export function parseNonEmptyObject(value: string, field: string) {
  return parseObject(value, field, true);
}

export function parseOptionalPositiveInteger(value: string, field: string) {
  if (!value.trim()) return undefined;
  if (!/^\d+$/.test(value) || Number(value) < 1) {
    throw new Error(`${field} must be a positive integer`);
  }
  return Number(value);
}
